import React from "react";
import { BookStore, Dispatcher } from "../../flux";
import { Spinner } from "../../components";

const gadgetId = "AnalyticsPanel";

class AnalyticsPanel extends React.Component {
  constructor() {
    super();
    this.state = {
      url: false,
      error: false
    };
  }

  componentDidMount() {
    Jigsaw.User.createLTILaunch(
      {
        type: "discourse_analytics",
        isbn: this.props.isbn,
        brand_key: Fraction.Brand.jigsawBrand
      },
      response => {
        if (response.isSuccess()) {
          this.setState({ url: response.data.redirect_url });
        } else {
          this.setState({ error: true });
        }
      }
    );
  }

  render() {
    if (this.state.error) {
      return <span>{i18n.t("messages.500-error")}</span>;
    } else if (this.state.url) {
      return (
        <span>
          <div
            className="hidden-request-accessible-version"
            role="complementary"
          >
            <p tabIndex="-1" />
          </div>
          <iframe
            id="discourse-analytics"
            width="100%"
            height="100%"
            src={this.state.url}
          />
        </span>
      );
    }
    return <Spinner />;
  }
}

module.exports = {
  class: AnalyticsPanel,
  metadata: () => {
    return {
      id: gadgetId,
      name: "Discourse Analytics",
      learnMore: false,
      launch: "// TODO",
      toggle: false,
      expanded: false,
      type: "panel",
      autoShow: false,
      enabled: () => {
        return (
          Fraction.Brand && Fraction.Brand.Sidebar.Buttons.discourseAnalytics
        );
      },
      sidebar: {
        icon: "/img/notebook-OLD.svg",
        activeMethod: "fill", // 'fill' or 'highlight'
        action: () => {
          Dispatcher.emit(Dispatcher.TOGGLE_PANEL, gadgetId);
        }
      }
    };
  }
};
